import React from 'react'
import { styled } from '@mui/material'
import { Toast as BaseToast } from '@chilecompra/react-kit/components'

export const Link = styled(({ children, textAlign, textDecoration, ...props }) => <a {...props}>{children}</a>)`
  align-content: baseline;
  color: ${({ color, theme }) => (color === 'primary' ? theme.palette.blue[50] : theme.palette.gray[50])};
  cursor: pointer;
  display: ${props => props.display || 'flex'};
  font-size: 14px;
  font-style: ${props => (props.italic ? 'italic' : 'initial')};
  line-height: 16px;
  text-align: ${props => props.textAlign || 'initial'};
  text-decoration: ${props => props.textDecoration || 'none'};

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`
export const Toast = styled(BaseToast)`
  &.MuiAlert-root {
    background-color: transparent;
    margin: 0;
    padding: 0;
    .MuiAlert-icon {
      margin-rigth: 10px;
    }
    .MuiAlert-message {
      font-size: 14px;
      padding: 7px 0;
      width: 100%;
    }
  }
`

export const Box = styled(({ children, padding, ...props }) => <div {...props}>{children}</div>)`
  padding: ${props => props.padding};
`
